import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"center"} }

import { shareInfo } from '@dc-platform/dc-interaction'
import useLocale from '@/hooks/useLocale'
import { getLanguage } from '@/lang'
import { useInteractionStore } from '@/stores/interaction'
import type { ConfigProviderProps } from 'ant-design-vue'
enum SystemLanguageEnum {
  'zh-cn' = 'zh-CN', // 简体中文（为了兼容主应用老版本）
  'en-us' = 'en-US', // 英文(为了兼容主应用老版本)
  'zh-CN' = 'zh-CN', // 简体中文
  'en-US' = 'en-US' // 英文
}


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const interactionStore = useInteractionStore()

const { antdLanguage, languageToggle } = useLocale()

const defaultConfig: ConfigProviderProps = {
  input: {
    autocomplete: 'off'
  }
}

const mainAppLanguage = SystemLanguageEnum[shareInfo.getLanguage()]
languageToggle(mainAppLanguage)
interactionStore.setLanguage(mainAppLanguage)
console.log(mainAppLanguage)
shareInfo.onLanguage((language: string) => {
  console.log('主应用切换语言 :>> ', language, getLanguage())
  interactionStore.setLanguage(getLanguage())
  languageToggle(SystemLanguageEnum[language])
})

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_empty = _resolveComponent("dc-layout-empty")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, _mergeProps({ locale: _unref(antdLanguage) }, defaultConfig), {
    renderEmpty: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_dc_layout_empty, { type: "nothing" })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }, 16, ["locale"]))
}
}

})